import React from 'react'
import { TextField } from '@mui/material'
import { any, string, func } from 'prop-types'
export default function FormResumeTextField({
  resumo,
  video,
  onChange,
  ...rest
}) {
  return (
    <TextField
      disabled={!!video}
      multiline
      label={video ? '' : 'Digite seu resumo aqui...'}
      minRows={12}
      maxRows={12}
      value={resumo}
      variant="outlined"
      sx={{
        width: '100%',
        backgroundColor: video ? '#c3c3c3' : '#ffffff'
      }}
      inputProps={{ minLength: '900', maxLength: '4000' }}
      color={resumo?.length < 900 ? 'error' : 'default'}
      onChange={onChange}
      {...rest}
    />
  )
}
FormResumeTextField.propTypes = {
  resumo: string,
  video: any,
  onChange: func
}
